/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface DebtorAgent {
  schemeName: string;
  identification: string;
}

export const debtorAgentSchema: Schema<DebtorAgent> = object({
  schemeName: ['SchemeName', string()],
  identification: ['Identification', string()],
});
